import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPostCounts } from "../../../../redux/posts/action";
import { useNavigate } from "react-router-dom";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import PaginationforJobsActive from "./PaginationforJobsActive";
import PaginationforJobsRecent from "./PaginationforJobsRecent";
import PaginationforJobsCompleted from "./PaginationforJobsCompleted";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import PaginationforJobsCancelled from "./PaginationforJobsCancelled";

export default function PaginationforContests() {
  const path = "Assets/scss/myorders.module.scss";
  const { urlstate, setMyAllJobListroute } = useRouteBaseStateContext();

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const navigate = useNavigate();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [activeTab, setActiveTab] = useState("paymentpendingjobs"); // State to track active tab
  const dispatch = useDispatch();
  const postcounts = useSelector(({ posts: { postcounts } }) => postcounts);

  useEffect(() => {
    dispatch(getPostCounts(2));
  }, [dispatch]);


  useEffect(() => {
    if (urlstate?.myalljoblistroute) {
      setActiveTab(urlstate?.myalljoblistroute || "paymentpendingjobs");
    } else {
      setActiveTab("paymentpendingjobs");
    }
  }, [urlstate, urlstate?.myalljoblistroute]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setMyAllJobListroute(tab);
  };
  return (
    <>
      <div className="order-section manage-project">
        <div className="tab-sec">
          <div className="order-first">
            <h2>My Orders</h2>
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <a
                  onClick={() => handleTabClick("paymentpendingjobs")}
                  className={`nav-link ${activeTab == "paymentpendingjobs" ? "active" : ""}`}
                >
                  Recent Posted Part time Job (PTJ) (
                  {postcounts?.posted_orders?.recent_job || 0})
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={() => handleTabClick("activejobs")}
                  className={`nav-link ${activeTab == "activejobs" ? "active" : ""}`}
                >
                  Active Part time Job (PTJ) ({postcounts?.posted_orders?.job || 0})
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={() => handleTabClick("active")}
                  className={`nav-link ${activeTab == "active" ? "active" : ""}`}
                >
                  Completed Part time Job (PTJ) ({postcounts?.completed_orders?.job || 0})
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={() => handleTabClick("Cancelled")}
                  className={`nav-link ${activeTab == "Cancelled" ? "active" : ""}`}
                >
                  Cancelled Part time Job (PTJ) ({postcounts?.cancelled_orders?.job || 0})
                </a>
              </li>
            </ul>
          </div>
          <div className="tab-content">
            {activeTab == "paymentpendingjobs" && (
              <div className="tab-pane active" id="paymentpendingjobs">
                <PaginationforJobsRecent />
              </div>
            )}
            {activeTab == "activejobs" && (
              <div className="tab-pane active" id="activejobs">
                <PaginationforJobsActive />
              </div>
            )}
            {activeTab == "active" && (
              <div className="tab-pane active" id="active">
                <PaginationforJobsCompleted />
              </div>
            )}
            {activeTab == "Cancelled" && (
              <div className="tab-pane active" id="Cancelled">
                <PaginationforJobsCancelled />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
